// The org switcher's "Try again" (AppOrgSwitcher `_commitOrgSwitch`, THE
// SWITCH DEADLINE): runs the switch that just failed or timed out once more.
// The failing switch parks itself on globalThis.__orgSwitchRetry (the same
// cross-package slot pattern as globalThis.__wsSwitchFallbackState), because
// the commit is component-private and the toast action resolves by name.
export function retryOrgSwitch () {
  const retry = globalThis.__orgSwitchRetry
  globalThis.__orgSwitchRetry = null
  return typeof retry === 'function' ? retry() : undefined
}
